import { render } from "./WritingTestView.vue?vue&type=template&id=f839a19e&scoped=true&lang=true"
import script from "./WritingTestView.vue?vue&type=script&lang=js"
export * from "./WritingTestView.vue?vue&type=script&lang=js"

import "./WritingTestView.vue?vue&type=style&index=0&id=f839a19e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f839a19e"]])

export default __exports__